import { inject } from "@angular/core";
import { BalanceQuery, config, MemberCard, MemberCardQuery, MemberDetails, MemberQuery } from "@fgb/core";
import { Observable } from "rxjs";

export class MemberCardBase{
    
    memberCardQuery: MemberCardQuery = inject(MemberCardQuery);
    memberQuery: MemberQuery = inject(MemberQuery);
    balanceQuery: BalanceQuery = inject(BalanceQuery);
    // productCodeQuery: ProductCodeQuery = inject(ProductCodeQuery);
    memberCard$: Observable<MemberCard | undefined>;
    // ecash$: Observable<number | undefined>;
    memberDetails$: Observable<MemberDetails | undefined>;
    pointsBalance$: Observable<number | undefined>;
    // combinedCard$: Observable<number | undefined>;

    init(): void{
        this.memberCard$ = this.memberCardQuery.selectCurrentCard();
        // this.combinedCard$ = this.balanceQuery.selectPurse(config.purseConfig.combined);
        this.memberDetails$ = this.memberQuery.selectMemberDetails();
        this.pointsBalance$ = this.balanceQuery.selectPurse(config.purseConfig.virtualLoyalty);
        // this.ecash$ = this.balanceQuery.selectPurse(config.purseConfig.combined);
    }

    
  }